import { create } from "zustand";

export const useCrmStore = create((set) => ({
  activeCustomColumn: null,
  setActiveCustomColumn: (value) => set({ activeCustomColumn: value }),
  isCustomColumnLockedModalOpen: false,
  setIsCustomColumnLockedModalOpen: (value) =>
    set({ isCustomColumnLockedModalOpen: value }),
  isAddCustomColumnModalOpen: false,
  setIsAddCustomColumnModalOpen: (value) =>
    set({ isAddCustomColumnModalOpen: value }),
  isEditCustomColumnModalOpen: false,
  setIsEditCustomColumnModalOpen: (value) =>
    set({ isEditCustomColumnModalOpen: value }),
  isDeleteCustomColumnModalOpen: false,
  setIsDeleteCustomColumnModalOpen: (value) =>
    set({ isDeleteCustomColumnModalOpen: value }),
  longTextValueModalOpen: "",
  setLongTextValueModalOpen: (value) => set({ longTextValueModalOpen: value }),
  customColumnsMasterObj: {},
  setCustomColumnsMasterObj: ({ value, featureKey }) =>
    set((state) => ({
      customColumnsMasterObj: {
        ...state.customColumnsMasterObj,
        [featureKey]: value,
      },
    })),
}));
